import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const indicatorStyle = {
    position: 'absolute',
    bottom: '20px',
    right: '20px',
    zIndex: 100,
    height: '40px',
    width: '40px',
    backgroundColor: '#5765F2',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    boxShadow: '0 -2px 5px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
};
const arrowStyle = {
    fontSize: '1.5em',
};
const DefaultNewMessageIndicator = ({ onClick, }) => (_jsx("div", Object.assign({ onClick: onClick, style: indicatorStyle }, { children: _jsx("span", Object.assign({ style: arrowStyle }, { children: "\u2193" })) })));
export default memo(DefaultNewMessageIndicator);
